import { render, staticRenderFns } from "./PlusSelectDiseaseCode.vue?vue&type=template&id=2989856a&scoped=true"
import script from "./PlusSelectDiseaseCode.vue?vue&type=script&lang=js"
export * from "./PlusSelectDiseaseCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989856a",
  null
  
)

export default component.exports